import React from 'react';
import { Container, Navbar } from 'react-bootstrap';

export default function BOHeader() {
  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container fluid>
        <Navbar.Brand href="/bo/menu">Timepocket Console Admin</Navbar.Brand>
      </Container>
    </Navbar>
  );
}
